// Things to do when page and content (images, styles, etc) are loaded in
jQuery(document).ready(() => {
	// Reinitialize jQuery's $ global after jQuery.noConflict() call in WP included jQuery
	$ = jQuery;

	scrollListener();
	navToggle();
	menuDropdowns();

	if ($("body.home").length || $("[data-template='object'").length) {
		slideSwitch();

		let slideshowInterval = setInterval(() => {
			slideSwitch(true);
		}, 10000);

		// Reset slideshow interval if slide was manually switched
		$(
			".carousel-nav .left, .carousel-nav .right, .carousel-left, .carousel-right"
		).click(function () {
			clearInterval(slideshowInterval);

			slideshowInterval = setInterval(() => {
				slideSwitch(true);
			}, 10000);
		});

		if ($("[data-template='object'").length) {
			carouselSlide();
			floorplanModal();
		}

		$(".slide-nav-item").on("click", slideModal());
	}

	if ($("[data-template=contact]").length) {
		$(".tos label").empty();
		$(".tos label").append(
			`<a href="${$(".tos-link").attr("href")}" target="_blank">${$(
				".tos input"
			).attr("value")}</a>`
		);
	}
});

function scrollListener() {
	let navBarOffset = $(".site-header .nav-bar").offset().top;
	let slideOutHeight = $(".slide-out-menu").outerHeight();
	let navContactHeight = $(".site-header > .contact-info").outerHeight();

	$(window).scroll(() => {
		if (navBarOffset <= $(window).scrollTop())
			$(".site-header").addClass("sticky");
		else $(".site-header").removeClass("sticky");

		// if (
		// 	$("body").hasClass("nav-open") &&
		// 	$(window).scrollTop() > slideOutHeight
		// ) {
		// 	$(document).scrollTop(slideOutHeight);
		// }
	});
}

function slideSwitch(auto = false) {
	if (auto == false) {
		$(".slide-nav-item").click(function () {
			let itemIndex = $(this).attr("data-index");
			$(".hero-bg.active").removeClass("active");
			$(".slide-nav-item.active").removeClass("active");
			$(this).addClass("active");
			$($(".hero-bg")[itemIndex]).addClass("active");
		});
		$(".carousel-nav .left").click(function () {
			let nextIndex =
				parseInt($(".slide-nav-item.active").attr("data-index")) - 1;
			$(".hero-bg.active").removeClass("active");
			$(".slide-nav-item.active").removeClass("active");
			if ($(`.slide-nav-item[data-index='${nextIndex}']`).length) {
				$(`.hero-bg[data-index='${nextIndex}']`).addClass("active");
				$(`.slide-nav-item[data-index='${nextIndex}']`).addClass(
					"active"
				);
			} else {
				$(".hero-bg[data-index='0']").addClass("active");
				$(".slide-nav-item[data-index='0']").addClass("active");
			}
		});
		$(".carousel-nav .right").click(function () {
			let nextIndex =
				parseInt($(".slide-nav-item.active").attr("data-index")) + 1;
			$(".hero-bg.active").removeClass("active");
			$(".slide-nav-item.active").removeClass("active");
			if ($(`.slide-nav-item[data-index='${nextIndex}']`).length) {
				$(`.hero-bg[data-index='${nextIndex}']`).addClass("active");
				$(`.slide-nav-item[data-index='${nextIndex}']`).addClass(
					"active"
				);
			} else {
				$(".hero-bg[data-index='0']").addClass("active");
				$(".slide-nav-item[data-index='0']").addClass("active");
			}
		});
	} else {
		let nextIndex =
			parseInt($(".slide-nav-item.active").attr("data-index")) + 1;
		$(".hero-bg.active").removeClass("active");
		$(".slide-nav-item.active").removeClass("active");
		if ($(`.slide-nav-item[data-index='${nextIndex}']`).length) {
			$(`.hero-bg[data-index='${nextIndex}']`).addClass("active");
			$(`.slide-nav-item[data-index='${nextIndex}']`).addClass("active");
		} else {
			$(".hero-bg[data-index='0']").addClass("active");
			$(".slide-nav-item[data-index='0']").addClass("active");
		}
	}
}

function slideModal() {
	let modalImage = $("#carouselModal .modal-image");
	let carouselCount = $(".slide-nav-item").length;
	let touchstartX = 0;
	let touchendX = 0;

	$(".slide-nav-item").click(function () {
		clickIndex = $(this).attr("data-index");

		let carouselIndex = parseInt($(this).attr("data-index"));
		$("#carouselModal .modal-title span").text(
			`${carouselIndex + 1} / ${carouselCount}`
		);

		modalImage
			.attr("src", $(`.hero-bg[data-index="${clickIndex}"]`).attr("src"))
			.attr("data-index", $(this).attr("data-index"));

		$("#carouselModal .modal-btn").attr(
			"href",
			$(`.hero-bg[data-index="${clickIndex}"]`).attr("src")
		);
	});

	$("#carouselModal .modal-dialog i.fa-arrow-left").on("click", () => {
		previousSlide();
	});
	$("#carouselModal .modal-dialog i.fa-arrow-right").on("click", () => {
		nextSlide();
	});

	$(document).on("keydown", (e) => {
		if ($("#carouselModal").hasClass("show")) {
			if (e.keyCode == 37) previousSlide();
			else if (e.keyCode == 39) nextSlide();
		}
	});

	function checkDirection() {
		if (touchendX < touchstartX) {
			if ($("#carouselModal").hasClass("show")) {
				nextSlide();
			}
		}

		if (touchendX > touchstartX) {
			if ($("#carouselModal").hasClass("show")) {
				previousSlide();
			}
		}
	}

	document.addEventListener("touchstart", (e) => {
		touchstartX = e.changedTouches[0].screenX;
	});

	document.addEventListener("touchend", (e) => {
		touchendX = e.changedTouches[0].screenX;
		checkDirection();
	});

	function previousSlide() {
		let previousSlideIndex = parseInt(modalImage.attr("data-index")) - 1;
		let previousSlidemage = $(
			`.hero-bg[data-index="${previousSlideIndex}"]`
		);

		if (previousSlidemage.length) {
			$("#carouselModal .modal-title span").text(
				`${previousSlideIndex + 1} / ${carouselCount}`
			);

			$("#carouselModal .modal-image")
				.attr("src", previousSlidemage.attr("src"))
				.attr("data-index", previousSlideIndex);

			$("#carouselModal .modal-btn").attr(
				"href",
				previousSlidemage.attr("src")
			);
		}
	}

	function nextSlide() {
		let nextSlideIndex = parseInt(modalImage.attr("data-index")) + 1;
		let nextSlideImage = $(`.hero-bg[data-index="${nextSlideIndex}"]`);

		if (nextSlideImage.length) {
			$(".modal-title span").text(
				`${nextSlideIndex + 1} / ${carouselCount}`
			);

			$(".modal-image")
				.attr("src", nextSlideImage.attr("src"))
				.attr("data-index", nextSlideIndex);

			$("#carouselModal .modal-btn").attr(
				"href",
				nextSlideImage.attr("src")
			);
		}
	}
}

function carouselSlide() {
	let carouselSize = $(".carousel-wrapper").width();
	let pageSize = $(".carousel .images").width();
	let slideSize = pageSize / 2;

	$(".carousel-right").click(function () {
		if (
			$(".carousel-wrapper").css("left").replace("px", "") >
			-(carouselSize - (pageSize + slideSize))
		) {
			// Check if next page is not last page
			$(".carousel-wrapper").animate({ left: `-=${slideSize}px` });
		} else {
			// Last page should completely show last image
			$(".carousel-wrapper").animate({
				left: `-${carouselSize - pageSize}px`,
			});
		}
	});

	$(".carousel-left").click(function () {
		if (
			parseInt($(".carousel-wrapper").css("left").replace("px", "")) >
			-pageSize
		) {
			$(".carousel-wrapper").animate({
				left: `0px`,
			});
		} else {
			$(".carousel-wrapper").animate({ left: `+=${slideSize}px` });
		}
	});
}

function floorplanModal() {
	let modalImage = $("#floorplanModal .modal-image");
	let floorplanCount = $(".floorplan").length;
	let touchstartX = 0;
	let touchendX = 0;

	$(".floorplan").click(function () {
		let floorplanIndex = parseInt($(this).attr("data-index"));
		$("#floorplanModal .modal-title span").text(
			`${floorplanIndex} / ${floorplanCount}`
		);

		modalImage
			.attr("src", $(this).attr("src"))
			.attr("data-index", $(this).attr("data-index"));

		$("#floorplanModal .modal-btn").attr("href", $(this).attr("src"));
	});

	$("#floorplanModal .modal-dialog i.fa-arrow-left").click(
		previousFloorplan()
	);
	$("#floorplanModal .modal-dialog i.fa-arrow-right").click(nextFloorplan());

	if ($("#floorplanModal").hasClass("show")) {
		if (e.keyCode == 37) previousFloorplan();
		else if (e.keyCode == 39) nextFloorplan();
	}

	function checkDirection() {
		if (touchendX < touchstartX) {
			if ($("#floorplanModal").hasClass("show")) {
				nextFloorplan();
			}
		}

		if (touchendX > touchstartX) {
			if ($("#floorplanModal").hasClass("show")) {
				previousFloorplan();
			}
		}
	}

	document.addEventListener("touchstart", (e) => {
		touchstartX = e.changedTouches[0].screenX;
	});

	document.addEventListener("touchend", (e) => {
		touchendX = e.changedTouches[0].screenX;
		checkDirection();
	});

	function previousFloorplan() {
		let previousFloorplanIndex =
			parseInt(modalImage.attr("data-index")) - 1;
		let previousFloorplanImage = $(
			`.floorplan[data-index="${previousFloorplanIndex}"]`
		);

		if (previousFloorplanImage.length) {
			$("#floorplanModal .modal-title span").text(
				`${previousFloorplanIndex} / ${floorplanCount}`
			);

			$("#floorplanModal .modal-image")
				.attr("src", previousFloorplanImage.attr("src"))
				.attr("data-index", previousFloorplanIndex);

			$("#floorplanModal .modal-btn").attr(
				"href",
				previousFloorplanImage.attr("src")
			);
		}
	}

	function nextFloorplan() {
		let nextFloorplanIndex = parseInt(modalImage.attr("data-index")) + 1;
		let nextFloorplanImage = $(
			`.floorplan[data-index="${nextFloorplanIndex}"]`
		);

		if (nextFloorplanImage.length) {
			$(".modal-title span").text(
				`${nextFloorplanIndex} / ${floorplanCount}`
			);

			$(".modal-image")
				.attr("src", nextFloorplanImage.attr("src"))
				.attr("data-index", nextFloorplanIndex);

			$("#floorplanModal .modal-btn").attr(
				"href",
				nextFloorplanImage.attr("src")
			);
		}
	}
}

function navToggle() {
	$(".nav-toggle").click(function () {
		$(this).find(".nav-icon").toggleClass("open");

		if ($("body").hasClass("nav-open")) {
			$(".slide-out-menu").animate({ left: `100%` });
		} else {
			if (!navigator.userAgent.match(/(iPod|iPhone|iPad)/)) {
				window.scrollTo({ top: 0, behavior: "auto" });
			}

			$(".slide-out-menu").animate({ left: `0px` });
		}

		$("body").toggleClass("nav-open");
	});
}

function menuDropdowns() {
	let dropdownItems = $(".menu-item-has-children");
	dropdownItems.append('<i class="icon"></i>');

	$(".menu-item-has-children").click(function () {
		$(".menu-item-has-children").toggleClass("open");
	});
}
